import React from 'react';
import RegisterCompany from './Registration/RegisterCompany';

const RegisterPage = () => {
    return (
        <RegisterCompany />
    );
};

export default RegisterPage;
